module.exports = new __parcel__URL__("meeting-notes-dark.d7bb00c4.svg").toString();